import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

import { JssNodeEnum } from '../../model/jss-tree-enum';
import { FormArray } from '@angular/forms/src/model';
import { NgRedux } from '@angular-redux/store';
import { IAppState } from '../../../store/store';
import * as _ from 'lodash';

interface IOption {
   value: string;
   viewValue: string;
}

@Component({
   selector: 'app-mat-select',
   templateUrl: './select.component.html',
   styleUrls: ['./select.component.scss']
})
export class SelectComponent implements OnInit, OnChanges {

   // public to access in template directly
   public _nodeName: string = null;
   public _nodeType: string = null;
   public _title = '';
   public _options: IOption[] = [];
   public _formControl: FormControl = null;
   public _formParent: FormGroup | FormArray = null;

   public _dict: any;

   @Input() jssTreeLeaf: JssNodeEnum;
   @Input() readonly = false;

   constructor(
    private _store?: NgRedux<IAppState>
   ) {
       this._dict = this._store.getState().navigationState.config['dictionary'];
       if (!this._dict) {
        console.warn('Dictionary nicht verfügbar');
       }
    }

   ngOnInit() {       
   }

   ngOnChanges() {
      if (this.jssTreeLeaf && !this.jssTreeLeaf.valuePassThrough) {
         this._nodeName = this.jssTreeLeaf.nodeName;
         this._nodeType = this.jssTreeLeaf.nodeType;
         this._formControl = this.jssTreeLeaf.getFormControl();
         this._formParent = this.jssTreeLeaf.getFormControlParent();
         this.readonly ? this._formControl.disable() : this._formControl.enable();
         // options: is array of strings
         this.jssTreeLeaf.options.forEach(element => {
            const de = this._dict && _.find(this._dict, (item) => item.short === element) || undefined;
            this._options.push({
               value: element,
               viewValue: de && de.long || element 
            });
         });

         // title
         if (this.jssTreeLeaf.showTitle) {
            this._title = this.jssTreeLeaf.hasTitle() ? this.jssTreeLeaf.title : this._nodeName;
         }

         // watch changes
         this._formControl.valueChanges.subscribe( val => {
            this.jssTreeLeaf.valueChanged(val);
         });
      }
   }

}



// WEBPACK FOOTER //
// /builds/cp/frap/t3/planer/src/app/core/json-form/material/select/select.component.ts